export const MatchScoreCardSkeleton = () => {
	return (
		<div className="animate-pulse rounded-lg border border-gray-200 bg-violet-25 p-5 shadow-xs">
			{/* Desktop layout (lg and above) */}
			<div className="hidden lg:block">
				<div className="mb-5 flex items-center justify-between">
					<div className="flex items-center gap-2">
						<div className="h-7 w-64 rounded-lg bg-gray-200" />
						<div className="size-4 rounded-lg bg-gray-200" />
					</div>
					<div className="h-8 w-24 rounded-lg bg-gray-200" />
				</div>

				<div className="flex items-start">
					<div className="mt-6 min-w-[120px]">
						<div className="h-7 w-20 rounded-lg bg-gray-200" />
					</div>
					<div className="flex-1">
						<div className="flex justify-between gap-8">
							<div className="flex-1">
								<div className="mb-2 h-5 w-16 rounded bg-gray-200" />
								<div className="flex gap-4">
									<div className="h-10 flex-1 rounded-lg bg-gray-200" />
									<div className="h-10 flex-1 rounded-lg bg-gray-200" />
								</div>
							</div>
							<div className="w-[45%]">
								<div className="flex items-center justify-center gap-4">
									{[...Array(6)].map((_, i) => (
										<div key={i} className="h-16 w-12 rounded-lg bg-gray-200" />
									))}
								</div>
							</div>
						</div>
					</div>
				</div>

				<hr className="my-5 border-gray-200" />

				<div className="flex items-start">
					<div className="mt-6 min-w-[120px]">
						<div className="h-7 w-20 rounded-lg bg-gray-200" />
					</div>
					<div className="flex-1">
						<div className="flex justify-between gap-8">
							<div className="flex-1">
								<div className="mb-2 h-5 w-16 rounded bg-gray-200" />
								<div className="flex gap-4">
									<div className="h-10 flex-1 rounded-lg bg-gray-200" />
									<div className="h-10 flex-1 rounded-lg bg-gray-200" />
								</div>
							</div>
							<div className="w-[45%]">
								<div className="flex items-center justify-center gap-4">
									{[...Array(6)].map((_, i) => (
										<div key={i} className="h-16 w-12 rounded-lg bg-gray-200" />
									))}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Tablet Layout (sm to lg) */}
			<div className="hidden sm:block lg:hidden">
				<div className="space-y-4">
					<div className="flex items-center justify-between gap-8">
						<div className="h-5 w-12 rounded bg-gray-200" />
						<div className="flex-1">
							<div className="mb-2 h-5 w-16 rounded bg-gray-200" />
							<div className="flex gap-4">
								<div className="h-10 flex-1 rounded-lg bg-gray-200" />
								<div className="h-10 flex-1 rounded-lg bg-gray-200" />
							</div>
						</div>
					</div>

					<div className="py-4">
						<div className="mx-auto w-[360px] space-y-2 md:w-[440px]">
							<div className="grid grid-cols-6 gap-2">
								{[...Array(6)].map((_, i) => (
									<div key={i} className="h-12 rounded-lg bg-gray-200" />
								))}
							</div>
						</div>
						<div className="mx-auto my-4 h-px w-[360px] bg-gray-200 md:w-[440px]" />
						<div className="mx-auto w-[360px] md:w-[440px]">
							<div className="grid grid-cols-6 gap-2">
								{[...Array(6)].map((_, i) => (
									<div key={i} className="h-12 rounded-lg bg-gray-200" />
								))}
							</div>
						</div>
					</div>

					<div className="flex items-center justify-between gap-8">
						<div className="h-5 w-12 rounded bg-gray-200" />
						<div className="flex-1">
							<div className="mb-2 h-5 w-16 rounded bg-gray-200" />
							<div className="flex gap-4">
								<div className="h-10 flex-1 rounded-lg bg-gray-200" />
								<div className="h-10 flex-1 rounded-lg bg-gray-200" />
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Mobile layout (xs only) */}
			<div className="block sm:hidden">
				<div className="mb-5 flex items-center justify-between">
					<div className="h-7 w-48 rounded-lg bg-gray-200" />
					<div className="size-6 rounded-lg bg-gray-200" />
				</div>

				<div className="space-y-4">
					<div className="space-y-2">
						<div className="h-7 w-20 rounded-lg bg-gray-200" />
						<div className="h-10 w-full rounded-lg bg-gray-200" />
						<div className="h-10 w-full rounded-lg bg-gray-200" />
					</div>

					<div className="space-y-4 py-4">
						<div className="flex justify-center gap-3">
							{[...Array(6)].map((_, i) => (
								<div key={i} className="h-16 w-12 rounded-lg bg-gray-200" />
							))}
						</div>
						<hr className="mx-auto my-4 w-full border-gray-200" />
						<div className="flex justify-center gap-3">
							{[...Array(6)].map((_, i) => (
								<div key={i} className="h-16 w-12 rounded-lg bg-gray-200" />
							))}
						</div>
					</div>

					<div className="space-y-2">
						<div className="h-7 w-20 rounded-lg bg-gray-200" />
						<div className="h-10 w-full rounded-lg bg-gray-200" />
						<div className="h-10 w-full rounded-lg bg-gray-200" />
					</div>

					<div className="mt-4 h-8 w-full rounded-lg bg-gray-200" />
				</div>
			</div>
		</div>
	);
};
